export default __webpack_public_path__ + "static/media/Game Room- Pool Table.be191ed4.jpg";